import { render, staticRenderFns } from "./RecordingChallengeDetail.vue?vue&type=template&id=57689dce&"
import script from "./RecordingChallengeDetail.vue?vue&type=script&lang=js&"
export * from "./RecordingChallengeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports